import React, { useEffect, useState } from "react";
import emailjs from "@emailjs/browser";
import "../App.css";
import Footer from "../components/Footer/Footer";

const Homepage = () => {
  const [activeSection, setActiveSection] = useState("home");
  // const [showBanner, setShowBanner] = useState(true);

  const products = [
    {
      id: 1,
      title: "Zivoro Analytics",
      description: "Advanced analytics platform for data-driven insights",
      features: [
        { name: "Real-time Analytics", icon: "/analytics-icon.svg" },
        { name: "Custom Reports", icon: "/reports-icon.svg" },
        { name: "Data Visualization", icon: "/visualization-icon.svg" },
        { name: "Predictive Analysis", icon: "/prediction-icon.svg" },
      ],
    },
    {
      id: 2,
      title: "Zivoro Cloud",
      description: "Secure and scalable cloud infrastructure solutions",
      features: [
        { name: "Cloud Storage", icon: "/storage-icon.svg" },
        { name: "Auto Scaling", icon: "/scaling-icon.svg" },
        { name: "Load Balancing", icon: "/balancer-icon.svg" },
        { name: "Cloud Security", icon: "/security-icon.svg" },
      ],
    },
    {
      id: 3,
      title: "Zivoro AI",
      description: "AI-powered solutions for business automation",
      features: [
        { name: "Machine Learning", icon: "/ml-icon.svg" },
        { name: "Natural Language", icon: "/nlp-icon.svg" },
        { name: "Computer Vision", icon: "/vision-icon.svg" },
        { name: "AI Automation", icon: "/automation-icon.svg" },
      ],
    },
  ];

  useEffect(() => {
    const handleScroll = () => {
      const sections = [
        "home",
        "expertise",
        "products",
        "problems",
        "excellence",
        "contact",
      ];
      const currentSection = sections.find((section) => {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          return rect.top <= 100 && rect.bottom >= 100;
        }
        return false;
      });
      if (currentSection) {
        setActiveSection(currentSection);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (e, sectionId) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      const navHeight = document.querySelector(".navbar").offsetHeight;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - navHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
      setActiveSection(sectionId);
    }
  };

  const Products = () => {
    const [currentProduct, setCurrentProduct] = useState(0);
    const products = [
      {
        title: "Zivoro Daily",
        description:
          "Your all-in-one solution for streamlining everyday business tasks. Manage vendors, customers, inventory, and sales with ease, while leveraging CRM tools, advanced analytics, and digital integration to enhance productivity and engagement.",
        features: [
          { name: "Inventory management", icon: "/images/inventory.svg" },
          { name: "Vendor & Customer management", icon: "/images/vendor.svg" },
          { name: "CRM engagement", icon: "/images/crm.svg" },
          { name: "Sales and Billing", icon: "/images/sales.svg" },
          { name: "Advance Booking", icon: "/images/advance.svg" },
          { name: "Digital Coin", icon: "/images/digital.svg" },
          { name: "Jewellery plans", icon: "/images/jewelry.svg" },
          {
            name: "Detailed reports and analytics",
            icon: "/images/detailed.svg",
          },
          { name: "Order management", icon: "/images/order.svg" },
          { name: "Tally Integration", icon: "/images/taper.svg" },
        ],
      },
      {
        title: "Zivo AI",
        description:
          "Zivo AI is your ultimate partner in leveraging data to its full potential. From real-time insights to predictive analytics, it transforms the way you approach decision-making. Whether you're analyzing sales trends, optimizing operational workflows, or forecasting future growth",
        features: [
          { name: "24*7 Service Available", icon: "/images/service.svg" },
          { name: "On demand report generation", icon: "/images/instant.svg" },
          { name: "Analytics on voice command", icon: "/images/voice.svg" },
          // { name: "Ask analytic reports anytime", icon: "/images/reports.svg" },
          // { name: "Advanced analytics details", icon: "/images/details.svg" },
          { name: "Reports on voice command", icon: "/images/command.svg" },
          { name: "Free to use at any time", icon: "/images/free.svg" },
          { name: "Creation on finger click", icon: "/images/creation.svg" },
          { name: "Complex reports generate", icon: "/images/complex.svg" },
          { name: "Visual data representation", icon: "/images/visual.svg" },
        ],
      },
      {
        title: "Zivoro Online",
        description:
          "Expand your business online with tools that make digital transformation effortless. From inventory-linked web stores to co-marketing tools and voice-enabled reports, Zivoro Online bridges the gap between offline operations and digital innovation.",
        features: [
          { name: "Inventory linked web store", icon: "/images/linked.svg" },
          { name: "Digital Coin for customers", icon: "/images/business.svg" },
          {
            name: "Campaign management & Marketing tool",
            icon: "/images/activated.svg",
          },
          // { name: "Company-wide management", icon: "/images/company.svg" },
          {
            name: "Online KYC Verification",
            icon: "/images/collaboration.svg",
          },
          {
            name: "Order-to-make functionality",
            icon: "/images/functionality.svg",
          },
        ],
      },
    ];

    const handlePrevProduct = () => {
      setCurrentProduct((prev) =>
        prev === 0 ? products.length - 1 : prev - 1
      );
    };

    const handleNextProduct = () => {
      setCurrentProduct((prev) =>
        prev === products.length - 1 ? 0 : prev + 1
      );
    };

    return (
      <section className="products" id="products" style={{ marginTop: "4rem" }} >
        <div className="product-container" >
          <h2 className="gradient-heading">Our Products</h2>
          <p
            className="section-subtitle"
            style={{
              textAlign: "center",
              fontSize: "clamp(0.875rem, 1.5vw, 1rem)",
              marginBottom: "2rem"
            }}
          >
            Your journey to finding the perfect products begins here. Explore
            Zivoro's listings to discover <br />
            solutions tailored to your needs and dreams. Start Your Journey
            Today:
          </p>

          <div className="products-content">
            <div className="products-showcase">
              <div
                className="products-track"
                style={{
                  transform: `translateX(-${currentProduct * 100}%)`,
                }}
              >
                {products.map((product, index) => (
                  <div
                    key={product.title}
                    className={`product-item ${index === currentProduct ? "active" : ""
                      }`}
                  >
                    {window.innerWidth > 768 ? (
                      <div className="product-features-circle">
                        {product.features.map((feature, featureIndex) => {
                          const angle =
                            ((featureIndex * 360) / product.features.length -
                              90) %
                            360;
                          const horizontalRadius =
                            window.innerWidth > 1400
                              ? 500
                              : window.innerWidth > 1200
                                ? 400
                                : window.innerWidth > 992
                                  ? 300
                                  : window.innerWidth > 768
                                    ? 250
                                    : 160;
                          const verticalRadius =
                            window.innerWidth > 1400
                              ? 300
                              : window.innerWidth > 1200
                                ? 225
                                : window.innerWidth > 992
                                  ? 200
                                  : window.innerWidth > 768
                                    ? 175
                                    : 120;

                          const x =
                            Math.cos((angle * Math.PI) / 180) *
                            horizontalRadius;
                          const y =
                            Math.sin((angle * Math.PI) / 180) * verticalRadius;

                          return (
                            <div
                              key={feature.name}
                              className="feature-item"
                              style={{
                                transform: `translate(calc(${x}px - 50%), calc(${y}px - 50%))`,
                                position: "absolute",
                                left: "50%",
                                top: "50%",
                              }}
                            >
                              <div className="feature-icon">
                                <img src={feature.icon} alt={feature.name} />
                              </div>
                              <span>{feature.name}</span>
                            </div>
                          );
                        })}
                        <div className="product-center">
                          <h3>{product.title}</h3>
                          <p>{product.description}</p>
                        </div>
                      </div>
                    ) : (
                      <div className="mobile-product">
                        <div className="product-center">
                          <h3>{product.title}</h3>
                          <p>{product.description}</p>
                        </div>
                        <div className="mobile-features">
                          {product.features.map((feature, idx) => (
                            <div key={idx} className="mobile-feature-item">
                              <div className="feature-icon">
                                <img src={feature.icon} alt={feature.name} />
                              </div>
                              <span>{feature.name}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>

            <div className="navigation-buttons">
              <button
                className="nav-arrow prev"
                onClick={handlePrevProduct}
                aria-label="Previous product"
              >
                <img
                  src="/images/arrowLeft.png"
                  alt="arrow_left" />
              </button>
              <button
                className="nav-arrow next"
                onClick={handleNextProduct}
                aria-label="Next product"
              >
                <img
                  src="/images/arrowRight.png"
                  alt="arrow_right" />
              </button>
            </div>
          </div>
        </div>
      </section>
    );
  };

  const Testimonials = () => {
    const [currentTestimonial, setCurrentTestimonial] = useState(0);
    const testimonials = [
      {
        id: 1,
        name: "Sushil Kumar",
        location: "Sumangali Jewellers",
        rating: 5,
        title: "Efficient",
        text: "30-40% customers send their installments on Gpay or phonepay. Our 7-member team, used to spend 4 hours each day locating these payments. After switching to Zivoro, just one member spends 10 mins to do this job.",
        avatar: "/images/sushil.jpeg",
      },
      {
        id: 2,
        name: "Bharath Acha",
        location: "Vishal Thangamaligai, Walajabad",
        rating: 5,
        title: "Great Technical Support",
        text: "While looking for webstore development i got to know about zivoro, here the service support is excellent. They schedule routine calls for reviews and discussions about new implementable ideas, which is amazing and helps us learn new things.",
        avatar: "/images/bharath.jpeg",
      },
      {
        id: 3,
        name: "Vinay",
        location: "(SJR) Jewellers, Royapuram",
        rating: 5,
        title: "Great UX",
        text: "When I considered upgrading our software, I had two concerns: pricing and the ease of use for other people at the store. I asked for demo account access and gave it to my father and surprisingly, he learnt how to use without any assistance",
        avatar: "/images/vinay.jpeg",
      },
    ];

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1200);

    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 1200);
      };

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    const totalSlides = testimonials.length;
    const maxSlides = isMobile ? totalSlides - 1 : totalSlides - 3;

    useEffect(() => {
      const timer = setInterval(() => {
        setCurrentTestimonial((prev) => (prev >= maxSlides ? 0 : prev + 1));
      }, 5000);

      return () => clearInterval(timer);
    }, [maxSlides]);

    const handlePrevTestimonial = () => {
      setCurrentTestimonial((prev) => (prev <= 0 ? maxSlides : prev - 1));
    };

    const handleNextTestimonial = () => {
      setCurrentTestimonial((prev) => (prev >= maxSlides ? 0 : prev + 1));
    };

    const renderStars = (rating) => {
      return Array.from({ length: rating }, (_, index) => (
        <span key={index} className="star">
          ★
        </span>
      ));
    };

    return (
      <>
        <section className="testimonials section-padding" id="testimonials">
          <div className="section-container">
            <div className="testimonials-header">
              <div className="title-container">
                <h2>Testimonials</h2>
              </div>
            </div>

            <div className="testimonials-content">
              <div className="testimonials-showcase">
                <div
                  className="testimonials-track"
                  style={{
                    transform: `translateX(-${currentTestimonial * (isMobile ? 100 : 33.333)
                      }%)`,
                  }}
                >
                  {testimonials.map((testimonial) => (
                    <div key={testimonial.id} className="testimonial-card">
                      <div className="testimonial-rating">
                        {renderStars(testimonial.rating)}
                      </div>
                      <h3 className="testimonial-title">{testimonial.title}</h3>
                      <p className="testimonial-text">{testimonial.text}</p>
                      <div className="testimonial-author">
                        <img src={testimonial.avatar} alt={testimonial.name} />
                        <div className="author-info">
                          <h4>{testimonial.name}</h4>
                          <p>{testimonial.location}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="testimonials-navigation">
                <button
                  className="nav-arrow prev"
                  onClick={handlePrevTestimonial}
                  aria-label="Previous testimonials"
                  style={{}}
                >
                  <img
                    src="/images/arrowLeft.png"
                    alt="arrow_left" />
                </button>
                <button
                  className="nav-arrow next"
                  onClick={handleNextTestimonial}
                  aria-label="Next testimonials"
                >
                  <img
                    src="/images/arrowRight.png"
                    alt="arrow_right" />
                </button>

              </div>

            </div>
          </div>

        </section>
        <hr style={{ width: "92%", margin: "1rem auto 0rem auto", height: "0.2px", color: " #262626" }} />
      </>

    );
  };


  const Contact = () => {
    const [formData, setFormData] = useState({
      name: "",
      email: "",
      phone: "",
      message: "",
      terms: false,
    });
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState({ type: "", message: "" });

    const handleChange = (e) => {
      const { name, value, type, checked } = e.target;
      setFormData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    };

    const handleSubmit = async (e) => {
      e.preventDefault();

      if (!formData.terms) {
        setStatus({
          type: "error",
          message: "Please accept the terms and conditions",
        });
        return;
      }

      setLoading(true);
      setStatus({ type: "", message: "" });

      try {
        const templateParams = {
          to_email: "runjhun@rainmakers.dev",
          from_name: formData.name,
          from_email: formData.email,
          from_mobile: formData.phone,
          message: formData.message,
        };

        await emailjs.send(
          "service_6s4e2lu",
          "template_3pgg547",
          templateParams,
          "alRXdMDZ7U6pFxyiY"
        );

        setStatus({
          type: "success",
          message: "Thank you for your message. We will get back to you soon!",
        });

        setFormData({
          name: "",
          email: "",
          phone: "",
          message: "",
          terms: false,
        });
      } catch (error) {
        console.error("EmailJS Error:", error);
        setStatus({
          type: "error",
          message: "Something went wrong. Please try again later.",
        });
      } finally {
        setLoading(false);
      }
    };

    return (
      <section className="contact" id="contact">
        <div className="section-container">
          <div className="contact-content">
            <div className="contact-text">
              <h2>Let's Connect</h2>
              <p>We're excited to connect with you and learn more</p>
            </div>
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Enter Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Enter your Email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="phone">Phone</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  placeholder="Share your mobile number"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  placeholder="Enter your Message here.."
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>
              <div className="terms-checkbox">
                <input
                  type="checkbox"
                  id="terms"
                  name="terms"
                  checked={formData.terms}
                  onChange={handleChange}
                />
                <label htmlFor="terms">
                  I agree with{" "}
                  <a
                    href="/terms-and-conditions"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Terms and Conditions
                  </a>{" "}
                  and{" "}
                  <a
                    href="/privacy-policy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </a>
                </label>
              </div>
              {status.message && (
                <div className={`form-status ${status.type}`}>
                  {status.message}
                </div>
              )}
              <button
                type="submit"
                className="btn btn-secondary"
                disabled={loading}
              >
                {loading ? "Sending..." : "Send Your Message"}
              </button>
            </form>
          </div>
        </div>
      </section>
    );
  };

  return (
    <div className="app">
      {/* Comment out the BannerPopup component */}
      {/* <BannerPopup /> */}
      <nav
        className="navbar"
      // style={{
      //   backgroundImage: "url(/images/Hero.png)",
      //   backgroundSize: "cover",
      //   backgroundRepeat: "no-repeat",
      // }}
      >
        <div className="nav-container">
          <div className="logo">
            <img src="/images/logo.png" alt="Logo" />
          </div>
          <div className="nav-links">
            <a
              href="#home"
              className={activeSection === "home" ? "active" : ""}
              onClick={(e) => handleNavClick(e, "home")}
            >
              Home
            </a>
            <a
              href="#products"
              className={activeSection === "products" ? "active" : ""}
              onClick={(e) => handleNavClick(e, "products")}
            >
              Products
            </a>
            <a
              href="#excellence"
              className={activeSection === "excellence" ? "active" : ""}
              onClick={(e) => handleNavClick(e, "excellence")}
            >
              About Us
            </a>
            <a
              href="#contact"
              className={activeSection === "contact" ? "active" : ""}
              onClick={(e) => handleNavClick(e, "contact")}
            >
              Contact
            </a>
          </div>
          <button className="nav-button">
            <a href="tel:+919602326570">Call Us +91-9602326570</a>
          </button>
        </div>
      </nav>

      <section className="hero" id="home">
        <video autoPlay loop muted playsInline className="hero-video">
          <source src="/images/video.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="hero-container">
          <div className="hero-content">
            <h1>
              Transform Your Jewellery Business
              <br />
              with Zivoro
            </h1>
            <p className="hero-description">
              The only software you’ll ever need.
              {/* <br />
              Your journey to finding the perfect products ends here. Explore
              Zivoro’s listings to discover more */}
            </p>
            <div className="hero-buttons">
              <button
                className="btn btn-outline"
                onClick={(e) => handleNavClick(e, "contact")}
              >
                Free Consultation
              </button>
              <button
                className="btn btn-primary"
                onClick={(e) => handleNavClick(e, "products")}
              >
                Browse Products
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="ai-expertise" id="expertise">
        <div className="ai-container">
          <h2>Zivo: Your Smartest Business Assistant</h2>
          <div className="expertise">
            <div className="expertise-grid">
              <div className="expertise-content">
                <div className="expertise-card">
                  <h3>Smart Insights for Smarter Decisions</h3>
                  <i>
                    &ldquo; What are the top-selling jewellery items in the last
                    30 days &rdquo;
                  </i>
                </div>
                <div className="expertise-card">
                  <h3>Real-Time Data at Your Fingertips</h3>
                  <i>
                    &ldquo; What is the current stock of gold bangles in our
                    inventory? &rdquo;
                  </i>
                </div>
                <div className="expertise-card">
                  <h3>Advanced AI for Business Efficiency</h3>
                  <i>
                    &ldquo; Can you generate a report of all unpaid invoices for
                    the last quarter? &rdquo;
                  </i>
                </div>
              </div>
              <div className="expertise-image">
                {/* <img src="/images/spiral.png" alt="AI Pattern" /> */}
                <video autoPlay loop muted playsInline className="ai-video">
                  <source src="/images/launch.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
                {/* <div className="typewriter-container">
                  <h1 className="typewriter-text">Launching Soon...</h1>
                </div>                 */}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Products />

      <section className="problems" id="problems">
        <div className="section-container">
          <h2>Problems we are solving</h2>
          <p
            className="section-subtitle"
            style={{
              textAlign: "center",
              fontSize: "clamp(0.875rem, 1.5vw, 1rem)",
              marginBottom: "6.5rem",
            }}
          >
            At Zivoro, we focus on solving key challenges that businesses face
            in their day-to-day <br />
            operations, enabling them to become more efficient, data-driven, and
            adaptable.
          </p>
          <div className="problems-grid">
            <div className="problem-card">
              <div className="problem-icon">
                <img src="/images/vendor.png" alt="Vendor Management" />
              </div>
              <h3>Vendor and Customer Management</h3>
              <p>
                Inefficient vendor and customer management is a common challenge
                for businesses, often leading to disorganized communication,
                manual tracking, and limited insights.
              </p>
            </div>
            <div className="problem-card">
              <div className="problem-icon">
                <img src="/images/analytics.png" alt="Business Analytics" />
              </div>
              <h3>Business Analytics</h3>
              <p>
                With fragmented data, manual tracking, and lack of real-time
                insights, there are missed opportunities and inefficiencies.
                Zivoro solves this by providing AI-driven business analytics,
                consolidating data into intuitive dashboards
              </p>
            </div>
            <div className="problem-card">
              <div className="problem-icon">
                <img src="/images/inventory.png" alt="Inventory Management" />
              </div>
              <h3>Inventory management</h3>
              <p>
                Jewellers struggle with overstocking, understocking, and stock
                wastage due to inefficient inventory management. With Zivoro
                Daily’s simplified and efficient inventory management you can
                optimize stock levels and streamline operations.
              </p>
            </div>
            <div className="problem-card">
              <div className="problem-icon">
                <img src="/images/billing.png" alt="Complex Sales & Billing" />
              </div>
              <h3>Complex Sales & Billing</h3>
              <p>
                Sales and billing is complex. We simplify these processes for
                invoicing, payment tracking, and order management. By
                streamlining workflows and reducing errors, Zivoro saves time,
                improves efficiency, and enhances customer satisfaction
              </p>
            </div>
          </div>
        </div>
      </section>

      <section id="excellence">
        <div className="section-container">
          <div className="excellence">
            <div className="excellence-content">
              <div className="excellence-text">
                <div className="excellence-card">
                  <h2>
                    We at <span className="gradient-text">Zivoro!</span>
                  </h2>
                  <ul>
                    <li>
                      At Zivoro, we are passionate about revolutionizing the way
                      businesses operate by offering cutting-edge solutions that
                      drive efficiency, enhance customer relationships, and
                      enable data-driven decision-making. With years of
                      experience in creating innovative tools, we are committed
                      to simplifying complex business processes and empowering
                      our clients to achieve greater success.
                    </li>
                    <li>
                      Our team, with 15 years of experience in solving complex
                      challenges and developing innovative software, excels at
                      delivering tailored tech solutions. Combining deep
                      industry expertise with surveys across jewellers, we are
                      committed to truly digitizing the jewellery sector.
                    </li>
                  </ul>
                  <div className="contact-info">
                    <div className="contact-item">
                      {/* <img src="/images/Facebook.svg" alt="Email" /> */}
                      <span class="material-icons">email</span>
                      <p>
                        <a href="mailto:contact@zivoro.ai">contact@zivoro.ai</a>
                      </p>
                    </div>
                    <div className="contact-item">
                      {/* <img src="/images/Facebook.svg" alt="Phone" /> */}
                      <span class="material-icons">phone</span>
                      <p>
                        <a href="tel:+919602326570">+91-9602326570</a>
                      </p>
                    </div>
                    <div className="contact-item">
                      {/* <img src="/images/Facebook.svg" alt="Location" /> */}
                      <span class="material-icons">location_on</span>
                      <p>
                        Office - No.42, H.No.3, Sri Rama Building Royal Placid
                        Layout, Phase 1, Haralur Main Road, Bangalore-560102
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="excellence-image">
                <img src="/images/about.jpeg" alt="Excellence" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mission" id="mission">
        <video autoPlay loop muted playsInline className="missionvideo">
          <source src="/images/banner.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="section-container">
          <div className="mission-header">
            <h2>Mission</h2>
            <p>Create.Educate.Scale</p>
          </div>
          <div className="mission-content">
            {/* <div className="mission-image">
              <img src="/images/mission.png" alt="Mission" />
            </div> */}
            <div className="mission-text">
              <p>
                Our mission is to transform the jewellery industry by bridging
                the technology gap with a unified solution. We strive to empower
                jewellers with innovative tools to drive meaningful digital
                transformation, helping the industry adapt to and thrive in a
                modern, tech-driven world.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Testimonials />

      <Contact />
      <Footer />
    </div>
  );
};

export default Homepage;
